import * as React from 'react'
import { Cart, Order } from '@medusajs/medusa'
import SidebarCard from '../SidebarCard'
import Price from '../Price'
import messages from '../../data/messages'
import getVariantPrice from 'web/src/lib/util/getVariantPrice'

const OrderOverview = ({ cartOrOrder }: { cartOrOrder: Cart | Order }) => {
    return (
        <SidebarCard>
            <div className="flex flex-col gap-y-4">
                <div className="flex flex-col gap-y-2">
                    <div className="flex items-center justify-between">
                        <p className="text-sm font-medium">Product</p>
                        <p className="text-sm font-medium">Totaal</p>
                    </div>
                    {cartOrOrder?.items.map(item => {
                        const variantPrice = getVariantPrice(item.variant.prices)
                        const originalTotal = variantPrice?.originalPrice
                            ? variantPrice.originalPrice * item.quantity
                            : null

                        return (
                            <div key={item.id} className="flex items-center justify-between gap-y-2">
                                <div className="flex items-center gap-x-2">
                                    <p className="text-sm shrink-0">{item.quantity}x</p>
                                    <p className="text-sm">{item.title}</p>
                                </div>
                                <div className="text-sm shrink-0 flex flex-col">
                                    {originalTotal && originalTotal !== item?.total && (
                                        <>
                                            <Price className="line-through opacity-50" price={originalTotal} />
                                        </>
                                    )}
                                    <Price price={item?.total} />
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="flex items-center justify-between border-t border-black pt-2">
                    <p className="text-sm">Totaal</p>
                    <Price className="text-sm" price={(cartOrOrder?.subtotal || 0) + (cartOrOrder?.tax_total || 0)} />
                </div>
                <div className="flex flex-col gap-y-2 border-t border-black pt-2">
                    <div className="flex items-center justify-between">
                        <p className="text-sm">Aanbetaling</p>
                        <Price
                            className="text-sm"
                            price={cartOrOrder.object === 'order' ? cartOrOrder?.paid_total : cartOrOrder?.total}
                        />
                    </div>
                    <p className="text-sm">{messages.depositDescription}</p>
                </div>
            </div>
        </SidebarCard>
    )
}

export default OrderOverview
